import ProjectFlowConfigContent from './ProjectFlowConfigContent'

export default ProjectFlowConfigContent
